import React from 'react'
import style from './PrimeraParte.module.css'

const PrimeraParte = ({ t }) => {
  return (
    <div className={style.container}>
      <p className={style.titulo}>{t('Products.FactoryScada.FirstPart.title')}&nbsp;{t('Products.FactoryScada.FirstPart.title2')}</p>
      <div className={style.divContainer}>
        <div className={style.divIzq}>
          <p className={style.text}>{t('Products.FactoryScada.FirstPart.text')}</p>
          <p className={style.text}>{t('Products.FactoryScada.FirstPart.text2')}</p>
          <p className={style.text}>{t('Products.FactoryScada.FirstPart.text3')}</p>
          <p className={style.text}>{t('Products.FactoryScada.FirstPart.text4')}</p>
          <p className={style.text}>{t('Products.FactoryScada.FirstPart.text5')}</p>
        </div>
        <div className={style.divDer}>
          <p className={style.text}>{t('Products.FactoryScada.FirstPart.text6')}</p>
          <p className={style.text}>{t('Products.FactoryScada.FirstPart.text7')}</p>
          <p className={style.title}>{t('Products.FactoryScada.FirstPart.title3')}</p>
          <div className={style.separador}></div>
          <ul className={style.ul}>
            <li className={style.li}>{t('Products.FactoryScada.FirstPart.li')}</li>
            <li className={style.li}>{t('Products.FactoryScada.FirstPart.li2')}</li>
            <li className={style.li}>{t('Products.FactoryScada.FirstPart.li3')}</li>
            <li className={style.li}>{t('Products.FactoryScada.FirstPart.li4')}</li>
            <li className={style.li}>{t('Products.FactoryScada.FirstPart.li5')}</li>
            <li className={style.li}>{t('Products.FactoryScada.FirstPart.li6')}</li>
            <li className={style.li}>{t('Products.FactoryScada.FirstPart.li7')}</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default PrimeraParte